import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { isValidAuthCode } from 'redux/modules/api/common'
import { notification, logError } from 'redux/modules/app'
import { parentalConsent as parentalConsentApi } from 'redux/modules/api'
import { schema } from 'models/parental-consent'
import appConfig from 'config'
import { PAYMENTS, ERROR_CODES } from 'constants/enums'
import queryString from 'query-string'

function decorator() {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        parentalConsent: api.parentalConsent
      }),
      { ...parentalConsentApi, notification, isValidAuthCode, logError }
    )
    class ParentalConsent extends Component {
      static propTypes = {
        sendParentalConsent: PropTypes.func.isRequired,
        getParticipantRegistration: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        isValidAuthCode: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired
      }

      state = {
        alreadySubmitted: false,
        isConsentGiven: false,
        isExpired: false,
        notValid: false
      }

      handleGetParentalConsent = async() => {
        const authCode = await this.handleGetAuthCode()

        if (authCode !== false) {
          return this.props
            .getParticipantRegistration(authCode)
            .catch(this.handleError)
        }

        return Promise.resolve({})
      }

      handleSendParentalConsent = async(fields, paymentType) => {
        const parentalAuthCode = await this.handleGetAuthCode()
        const orgId = get(this.props, 'parentalConsent.data.organizationId')

        return this.props
          .sendParentalConsent(parentalAuthCode, schema(fields))
          .then(({ body }) => {
            const authCode = get(body, 'authorizationCode')

            if (paymentType === PAYMENTS.ONLINE_MASTERCARD.id && authCode) {
              window.location.replace(`${appConfig.foUrl}/mpg-init/${authCode}`)
            } else if (paymentType === PAYMENTS.PAYPAL.id && authCode) {
              window.location.replace(
                `${appConfig.foUrl}/paypal-init/${authCode}`
              )
            } else if (paymentType === PAYMENTS.GPE.id && authCode) {
              window.location.replace(
                `${appConfig.foUrl}/gp-init/${orgId}/${authCode}`
              )
            } else if (paymentType === PAYMENTS.GPWP.id && authCode) {
              window.location.replace(
                `${appConfig.foUrl}/gp-wp-init/${authCode}`
              )
            } else {
              this.handleSubmit()
            }
          })
          .catch(this.handleError)
      }

      handleGetAuthCode = async() => {
        try {
          const query = queryString.parse(get(this.props, 'location.search'))
          const authCode = get(query, 'authorizationCode')
          const { body: isValid } = await this.props.isValidAuthCode(authCode)

          if (isValid.value === false) {
            this.setState({ isConsentGiven: true })
            return false
          }

          return authCode
        } catch (err) {
          this.setState({ isExpired: true })
          return false
        }
      }
      handleSubmit = () => {
        this.props.notification('Parental consent has been sent', {
          status: 'success',
          intlKey: 'notifications.parental_consent_has_been_sent'
        })
        this.setState({ alreadySubmitted: true })
      }

      handleError = (err = {}) => {
        this.props.logError(err)
        if (
          err.body.errorCode === 401 ||
          err.body.errorCode === 403 ||
          err.body.errorCode === ERROR_CODES.unauthorized.id ||
          err.body.errorCode === ERROR_CODES.authCodeExpired.id
        ) {
          this.setState({ notValid: true })
        }
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            {...this.state}
            onGetParentalConsent={this.handleGetParentalConsent}
            alreadySubmitted={this.state.alreadySubmitted}
            notValid={this.state.notValid}
            onSendParentalConsent={this.handleSendParentalConsent}
          />
        )
      }
    }
    return ParentalConsent
  }
}

export default decorator
